
import React from 'react';
import DashboardLayout from '@/components/layout/DashboardLayout';
import PageTransition from '@/components/ui/page-transition';
import { PolicyFlowEditor } from '@/components/policies/PolicyFlowEditor';
import { useSearchParams } from 'react-router-dom';

const PolicyEditor = () => {
  const [searchParams] = useSearchParams();
  const policyId = searchParams.get('id');
  
  return (
    <DashboardLayout>
      <PageTransition>
        <div className="h-[calc(100vh-4rem)] w-full">
          <PolicyFlowEditor policyId={policyId ? parseInt(policyId) : undefined} />
        </div>
      </PageTransition>
    </DashboardLayout>
  );
};

export default PolicyEditor;
